import apiClient from "./client";
import {
  hexToBackendColor,
  jsonBlob,
  mapRestaurantResponse,
  type BackendRestaurantResponse,
} from "./adapters";
import type { Restaurant, RegistrationRequest } from "@/types";

export const restaurantApi = {
  register: async (data: RegistrationRequest): Promise<void> => {
    const formData = new FormData();

    formData.append(
      "restaurant",
      jsonBlob({
        name: data.restaurantName,
        color: data.restaurantColor,
      })
    );
    formData.append(
      "user",
      jsonBlob({
        name: data.userName,
        email: data.userEmail,
        password: data.userPassword,
      })
    );

    if (data.restaurantImage) {
      formData.append("image", data.restaurantImage);
    }

    await apiClient.post("/restaurant", formData);
  },

  getRestaurant: async (): Promise<Restaurant> => {
    const response = await apiClient.get<BackendRestaurantResponse>(
      "/restaurant/me"
    );
    return mapRestaurantResponse(response.data);
  },

  updateRestaurant: async (data: {
    name: string;
    color?: string;
    image?: File;
  }): Promise<Restaurant> => {
    const formData = new FormData();

    formData.append(
      "restaurant",
      jsonBlob({
        name: data.name,
        color: hexToBackendColor(data.color),
      })
    );
    if (data.image) formData.append("image", data.image);

    await apiClient.patch("/restaurant", formData);
    return restaurantApi.getRestaurant();
  },
};
